<rl-lti-alert [paramMap]="queryParamMap"></rl-lti-alert>

<button
  *ngIf="showBackButton"
  i18n="@@listView-btn-backToSuggestedLists"
  class="btn btn-primary btn-lg btn-responsive qa-list-view__back-to-suggested-lists"
  (click)="backToSuggestedLists()"
>
  Back to suggested lists
</button>

<button
  *ngIf="showEmbedDifferentListButton"
  i18n="@@listView-btn-embed-different-list"
  class="btn btn-primary btn-lg btn-responsive qa-list-view__embed-different-list"
  (click)="navigateToRelinkContentSelection()"
>
  Embed a different list
</button>

<rl-list-details
  [list]="listDetails$ | async"
  [editableList]="editableList$ | async"
  [containerMode]="containerMode"
  [defaultListAccess]="defaultListAccess$ | async"
  [isInMyLists]="listSubscription$ | async"
  [currentCitationStyle]="currentCitationStyle$ | async"
  [currentUser]="currentUser"
  [tenantCitationStyles]="citationStyles$ | async"
  (addToMyLists)="onAddToMyLists($event)"
  (showArchiveListModal)="showArchiveListModal($event)"
  (showDeleteListModal)="showDeleteListModal($event)"
  (showEditListDetailsModal)="showListDetailsEditorModal($event)"
  (showAssignListOwnersModal)="showAssignListOwnersModal($event)"
  (showRequestReviewModal)="showRequestReviewModal($event)"
  (showReviewHistoryModal)="showReviewHistoryModal($event)"
  (showStudentNumbersAndHierarchyModal)="
    showStudentNumbersAndHierarchyModal($event)
  "
>
</rl-list-details>

<section class="well c-container-filters">
  <div class="c-container-filters__menus">
    <rl-table-of-contents
      [containerRoot]="containerRoot"
      [containerStructure]="containerStructure$ | async"
      [sectionsById]="sectionsById$ | async"
      [disabled]="hasFilter$ | async"
    >
    </rl-table-of-contents>

    <rl-resource-type-filter-menu
      [resourceTypeFilter]="resourceTypeFilter$ | async"
      (resourceTypeFilterUpdate)="onResourceTypeFilter($event)"
      [itemCount]="itemCountByResourceTypeFilter$ | async"
      (clearAll)="onClearResourceTypeFilter()"
    >
    </rl-resource-type-filter-menu>

    <rl-quick-filters-menu
      [containerMode]="containerMode"
      [areAnnotationsResolved]="areAnnotationsResolved$ | async"
      [readingIntentionsByResource]="readingIntentionsByResource$ | async"
      [onlineResourcesByItem]="onlineResourcesByItem$ | async"
      [studyNotesByResource]="studyNotesByResource$ | async"
      [importances]="importances$ | async"
      [quickFilter]="quickFilter$ | async"
      (quickFilterUpdate)="onQuickFilter($event)"
      [itemCount]="itemCountByQuickFilters$ | async"
      (clearAll)="onClearQuickFilter()"
    >
    </rl-quick-filters-menu>

    <rl-citation-switcher-menu
      [currentCitationStyle]="currentCitationStyle$ | async"
      [tenantCitationStyles]="citationStyles$ | async"
      (changeCitationStyle)="changeCitationStyle($event)"
    >
    </rl-citation-switcher-menu>
  </div>

  <rl-items-filter
    [filterText]="textFilter$ | async"
    (applyTextFilter)="onTextFilter($event)"
    class="c-container-filters__search"
  >
  </rl-items-filter>
</section>

<rl-list-alerts
  [filterText]="textFilter$ | async"
  [hasVisibleEntries]="hasVisibleEntries$ | async"
  [resourceTypeFilter]="resourceTypeFilter$ | async"
  [quickFilter]="quickFilter$ | async"
  [hasCitationErrors]="hasItemCitationErrors$ | async"
  [list]="listDetails$ | async"
  [editableList]="editableList$ | async"
  [currentUserPermissions]="permissions"
  (clearResourceTypeFilter)="onClearResourceTypeFilter()"
  (clearQuickFilter)="onClearQuickFilter()"
  (clearTextFilter)="onClearTextFilter()"
>
</rl-list-alerts>

<rl-view-list-as-student></rl-view-list-as-student>

<rl-view-container
  [containerRoot]="containerRoot"
  [containerStructure]="containerStructure$ | async"
  [entryVisibility]="filteredEntryIds$ | async"
  [sectionsById]="sectionsById$ | async"
>
</rl-view-container>

<rl-list-license
  [editableList]="editableList$ | async"
  [licenses]="licenses$ | async"
>
</rl-list-license>

<rl-sticky-footer-bar [containerMode]="containerMode"></rl-sticky-footer-bar>

<rl-archive-list-modal></rl-archive-list-modal>
<rl-delete-list-modal></rl-delete-list-modal>

<rl-list-details-editor-modal
  [editableList]="editableList$ | async"
  [currentUserPermissions]="permissions"
  [licenses]="licenses$ | async"
  [timePeriods]="timePeriods$ | async"
>
</rl-list-details-editor-modal>

<rl-request-review-modal></rl-request-review-modal>
<rl-review-history-modal></rl-review-history-modal>
<rl-list-owners-editor-modal
  [currentUser]="currentUser"
  [listOwners]="(editableList$ | async).owners"
></rl-list-owners-editor-modal>
<rl-nodes-editor-modal [permissions]="permissions"></rl-nodes-editor-modal>
<rl-share-sheet-modal></rl-share-sheet-modal>
<rl-report-broken-link-modal></rl-report-broken-link-modal>
